import {Injectable} from '@angular/core';
import {SidenavFilter, SidenavFilterChain, SidenavItem} from '@mctic/ng-core';
import {Observable, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {ConfiguracaoAnoBaseService, EmpresaService, SecurityService} from 'src/app/service';
import {TipoConfiguracaoAnoBaseEnum} from 'src/app/shared/enum/tipo-configuracao-ano-base.enum';
import {SigplaniModuloEnum} from '../../shared/enum/sigplani-modulo.enum';
import {SidenavItemEnum} from '../sidenav-item.enum';

@Injectable({
  providedIn: 'root'
})
export class EmpresaContratanteSidenavFilter implements SidenavFilter {

  readonly mappings: string[] = [
    SidenavItemEnum.FaturamentoProduto,
    SidenavItemEnum.FaturamentoProdutoLei10356,
    SidenavItemEnum.Auditoria,
    SidenavItemEnum.AnexarRelatorioConclusivo,
    SidenavItemEnum.GerirPleito,
    SidenavItemEnum.GerirEntidade,
    SidenavItemEnum.VincularContrante,
    SidenavItemEnum.ConfigurarParametro,
    SidenavItemEnum.Auditoria,
    SidenavItemEnum.CartaCredito,
    SidenavItemEnum.RetificarCartaCredito
  ];

  readonly skipping: string[];

  constructor(
    private readonly securityService: SecurityService,
    private readonly empresaService: EmpresaService,
    private readonly configuracaoAnoBaseService: ConfiguracaoAnoBaseService) {
  }

  canActivate(_: SidenavItem): Observable<boolean> {
    return of(this.securityService.isModuloAtivo(SigplaniModuloEnum.RDA) &&
      this.empresaService.isEmpresaContratante());
  }

  doFilter(sidenavItem: SidenavItem, chain: SidenavFilterChain): Observable<boolean> {
    const idAnoBase = this.securityService.usuarioSessao.anoBase.id;
    return this.configuracaoAnoBaseService.obterConfiguracaoAnoBasePorIdAnoBase(idAnoBase).pipe(
      map(configuracao => {
          const periodoSuspensao = this.configuracaoAnoBaseService.obterConfiguracao(configuracao.configuracaoAnoBase,
            TipoConfiguracaoAnoBaseEnum.EntregaRdaSuspensao);
          let isSuspensa = false;
          if (this.configuracaoAnoBaseService.isPeriodo(periodoSuspensao)) {
            return isSuspensa = this.empresaService.obterEmpresaAutenticada().suspensaRda;
          }
          return !this.configuracaoAnoBaseService.isPeriodoPreenchimentoRda(configuracao.configuracaoAnoBase);
        }
      ),
      switchMap(ativo => chain.nextOrComplete(sidenavItem, ativo))
    );
  }

}
